export const userEndpoints = {
  getUser: `/user`,
  updateUserOrg: `/user/update-with-organization`,
};
